<template>
	<div class="job-bot">
		<div class="sidebar-jon">
			<div class="sidebar-jon--avatar">
				<div>
					<Jon/>
					<div class="arrow-down"></div>
				</div>
				<div>Skilly hilft dir gerne weiter:</div>
			</div>
			<ul class="sidebar-jon--items">
				<li
					v-for="(message, i) in messages"
					:key="'message-' + i"
					:class="'sidebar-jon--item sidebar-jon--item-' + i"
				>
					<span v-html="message"/>
				</li>
			</ul>
		</div>
		<div class="button-container">
			<Button
				:text="buttonText"
				icon="checkmark"
				:style="{'animation-delay': (messages.length) + 's'}"
				@click="start"
			/>
		</div>
	</div>
</template>

<script>
import Button from "@/vue/common/Button";
import {mapActions} from "vuex";
import Jon from "@/vue/common/image/Jon.vue";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";

export default {

	components: {
		Jon,
		Button,
	},

	props: {
		job: {
			type: Object,
			required: true,
		},
		applicationData: {
			type: Object,
			required: false,
		}
	},

	computed: {
		hasPreListingItems ()
		{
			return this.job.questionnaire.hasPreListingItems;
		},
		buttonText ()
		{
			return this.hasPreListingItems
				? 'Los geht\'s'
				: 'Frag mich!';
		},
		messages ()
		{
			return [
				'Schön, dass du hier bist!',
				'Um dir passende Job-Matches anzuzeigen, brauche ich noch ein paar weitere Informationen. Erzähle mir mehr, damit ich dir deinen Traumjob zeigen kann.',
				'Möchtest du jetzt ein paar Fragen beantworten?'
			];
		}
	},

	methods: {
		...mapActions('job/bot', [
			'showQuestionnaire'
		]),
		start ()
		{
			Event.push(
				new EventData()
					.setEvent(Event.QUESTIONNAIRE)
					.setAction('Öffnen')
			);

			this.showQuestionnaire({
				job: this.job,
				onContinueLater: data =>
				{
					this.$emit('continueLater', data);
				},
				onClose: data =>
				{
					this.$emit('close', data);
				},
			});
		},
	},
}
</script>
